import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { UpcomingTitleGraphqlFragmentDoc } from '../fragments/UpcomingTitle.fragment';
export type GetUpcomingTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	pageType: Types.NewPageType;
	language: Types.Scalars['Language']['input'];
	bucketType?: Types.InputMaybe<Types.NewDateRangeBucket>;
	profile?: Types.InputMaybe<Types.PosterProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	platform: Types.Platform;
	filter: Types.WatchNowOfferFilter;
	newTitlesFilter2?: Types.InputMaybe<Types.TitleFilter>;
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	first: Types.Scalars['Int']['input'];
}>;

export type GetUpcomingTitlesQuery = {
	__typename?: 'Query';
	newTitles: {
		__typename?: 'NewTitlesConnection';
		totalCount: number;
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
		edges?: Array<{
			__typename?: 'NewTitlesEdge';
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						freeOffersCount: number;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							isReleased: boolean;
							scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number; progress: number };
						content: {
							__typename?: 'SeasonContent';
							seasonNumber: number;
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							isReleased: boolean;
							scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
						};
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						show: {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							content: {
								__typename?: 'ShowContent';
								title: string;
								shortDescription?: string | null;
								fullPath: string;
								posterUrl?: string | null;
								runtime?: number | null;
								scoring: {
									__typename?: 'Scoring';
									imdbVotes?: number | null;
									imdbScore?: number | null;
									tmdbPopularity?: number | null;
									tmdbScore?: number | null;
								};
								genres: Array<{ __typename?: 'Genre'; translation: string }>;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: { __typename?: 'ShowSeenState'; progress: number };
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  };
		}> | null;
	};
};

export const GetUpcomingTitlesDocument = gql`
	query GetUpcomingTitles(
		$country: Country!
		$pageType: NewPageType!
		$language: Language!
		$bucketType: NewDateRangeBucket
		$profile: PosterProfile
		$format: ImageFormat
		$platform: Platform!
		$filter: WatchNowOfferFilter!
		$newTitlesFilter2: TitleFilter
		$after: String
		$first: Int!
	) {
		newTitles(
			country: $country
			pageType: $pageType
			bucketType: $bucketType
			filter: $newTitlesFilter2
			after: $after
			first: $first
		) {
			totalCount
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				node {
					...UpcomingTitleGraphql
				}
			}
		}
	}
	${UpcomingTitleGraphqlFragmentDoc}
`;
